import axios from 'axios';

const url = window.apiUrl;

if (document.querySelector('[name="api-token"]')) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${document.querySelector('[name="api-token"]')?.content}`;
}

const findTrail = async id => {
  const res = await axios.get(`${url}/trails/${id}`);
  return res.data;
}

const getPrices = async (trailId, date, equipments = []) => {
  // {
  //   "trailId": 1,
  //   "date": "2022-02-11T08:00:00.000Z",
  //   "equipments": [
  //     { "id": 1, "count": 4 }
  //   ]
  // }
  const data = {
    trailId,
    date,
    equipments,
  };
  const res = await axios.post(`${url}/prices/check`, data);
  return res.data;
}

const findAvailableEquipments = async (trailId, date, equipments = []) => {
  // "trailId": 1,
  // "date": "2022-02-11T08:00:00.000Z",
  // "equipments": [
  //   { "equipmentToTrailId": 1, "count": 4 }
  // ]
  const data = {
    trailId,
    date: date+'T00:00:00.000Z',
    equipments,
  };
  const res = await axios.post(`${url}/availability/check`, data);
  return res.data;
}

const confirmAvailableEquipments = async (trailId, date, equipments = []) => {
  // "trailId": 1,
  // "date": "2022-02-11T08:00:00.000Z",
  // "equipments": [
  //   { "equipmentToTrailId": 1, "count": 4 }
  // ]
  const data = {
    trailId,
    date,
    equipments,
  };
  const res = await axios.post(`${url}/availability/confirm`, data);
  return res.data;
}

const makeOrder = async data => {
  // {
  //   "trailId": 1,
  //   "price": 1200,
  //   "equipments": [
  //     { "id": 1, "equipmentToTrailId"?: 1, "count": 2 }
  //   ],
  //   "userFirstName": "Adam",
  //   "userLastName": "Test",
  //   "userEmail": "adam@test.com",
  //   "userPhone": "123456789",
  //   "date": "2022-02-11T09:00:00.000Z"
  // }
  const res = await axios.post(`${url}/orders`, data)
  return res.data;
}

const checkOrderStatus = async id => {
  const res = await axios.get(`${url}/orders/${id}/status`);
  return res.data;
}

// const getOrdersByDay = async date => {
//   // TODO: missing trail id
//   const res = await axios.get(`${url}/orders/${date}`);
//   return res.data;
// }

const getSlotsWithOrdersByDay = async (trailId, date) => {
  const res = await axios.get(`${url}/orders/trails/${trailId}/${date}`);
  return res.data;
}

const changePaymentStatus = async (id, status) => {
  const res = await axios.put(`${url}/payments/${id}/status`, { status });
  return res.data;
}

const deleteOrder = async id => {
  const res = await axios.delete(`${url}/orders/${id}`);
  return res.data;
}

const updateOrder = async (id, data) => {
  const res = await axios.put(`${url}/orders/${id}`, data);
  return res.data;
}

const checkTimeBuffers = async (trailId, date) => {
  const res = await axios.get(`${url}/time-buffers/${trailId}/${date}`);
  return res.data;
}

// const sentTicket = async (orderId) => {
//   const res = await axios.post(`${url}/orders/${orderId}/send-ticket`);
//   return res.data;
// }

const searchTrails = async (params) => {
  const res = await axios.get(`${url}/search`, {
    params,
  });
  return res.data
}

const getCompanies = async (params) => {
  const res = await axios.get(`${url}/super-admin/companies`, {
    params,
  });
  return res.data
}

const getCompaniesScrapped = async (params) => {
  const res = await axios.get(`${url}/super-admin/companies/scrapped`, {
    params,
  });
  return res.data
}

const addEquipment = async (equipment) => {
    console.log(equipment);
    const res = await axios.post(`${url}/equipments`, equipment);
    return res.data;
};

const editEquipment = async (equipmentId, equipment) => {
    console.log(equipmentId);
    const res = await axios.put(`${url}/equipments/${equipmentId}`, equipment);
    return res.data;
};



export default {
    findTrail,
    findAvailableEquipments,
    makeOrder,
    checkOrderStatus,
    // getOrdersByDay,
    getSlotsWithOrdersByDay,
    changePaymentStatus,
    confirmAvailableEquipments,
    getPrices,
    // sentTicket,
    deleteOrder,
    updateOrder,
    checkTimeBuffers,
    searchTrails,
    getCompanies,
    getCompaniesScrapped,
    addEquipment,
    editEquipment,
};
